var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkforce(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_468_1885)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6744 14.0029L10.6736 12.6695C10.6733 11.9623 10.3919 11.2842 9.89157 10.7844C9.39121 10.2845 8.71278 10.0039 8.00553 10.0043L4.00553 10.0065C3.29829 10.0069 2.62016 10.2882 2.12034 10.7886C1.62051 11.2889 1.33993 11.9674 1.34031 12.6746L1.34103 14.0079",
    stroke: "#003D7A",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00354 7.33873C7.4763 7.33793 8.66956 6.14337 8.66876 4.67061C8.66796 3.19786 7.47341 2.0046 6.00065 2.00539C4.52789 2.00619 3.33463 3.20075 3.33543 4.6735C3.33623 6.14626 4.53078 7.33952 6.00354 7.33873Z",
    stroke: "#003D7A",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.674 14.0008L14.6733 12.6674C14.6725 12.0766 14.4755 11.5027 14.1133 11.0359C13.7511 10.5692 13.244 10.2359 12.6719 10.0885",
    stroke: "#003D7A",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.668 2.0896C11.2417 2.23616 11.7503 2.56948 12.1136 3.03703C12.4769 3.50457 12.6743 4.07974 12.6746 4.67185C12.6749 5.26396 12.4782 5.83934 12.1153 6.30728C11.7525 6.77521 11.2443 7.10909 10.6708 7.25627",
    stroke: "#003D7A",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_468_1885"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.00866935) rotate(-0.0310448)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkforce);
export default __webpack_public_path__ + "static/media/workforce.8cac2deeb7636420db55e78261c56815.svg";
export { ForwardRef as ReactComponent };